import React from "react"

import { Plus } from "lucide-react"
import { SearchHeader } from "../../../components/SearchHeader"
import useSearchParamStore from "../../../stores/SearchParamStore"
import useStyles from "../../styles"
import { Button } from "@material-ui/core"

const UsersLayout = () => {
  const classes = useStyles()
  const { searchParam, setSearchParam, setOpenModal } = useSearchParamStore()
  const handleOpenUserModal = () => {
    setOpenModal(true)
  }
  return (
    <div className={classes.buttonContainer}>
      <Button
        variant="contained"
        startIcon={<Plus />}
        color="primary"
        className={classes.buttonNova}
        disableElevation
        onClick={handleOpenUserModal}
      >
        Novo
      </Button>
      <SearchHeader searchParam={searchParam} setSearchParam={setSearchParam} placeholder={"Pesquisar..."} />
    </div>
  )
}

export default UsersLayout
